<template>
    <header id="page-header" class="page-header" :class="pageType" v-if="currentPage" :key="viewKey">
        <template v-if="false">
            
            <section class="top-section section-full">
                
                <section class="inner-wrapper">
                    <div class="nav-wrapper dark" v-bind:class="{ 'open' : openNav}">
                        <router-link to="/" class="logo-wrapper">
                            <wpImage 
                                v-if="logoWhite"
                                :data="logoWhite" 
                                class="page-logo"
                            />
                        </router-link>
                        <div class="burger-wrapper">
                            <div 
                                class="hamburger hamburger--slider"
                                v-on:click="openNav = !openNav"
                                role="button"
                            >
                                <div class="hamburger-box">
                                <div class="hamburger-inner"></div>
                                </div>
                            </div>
                        </div>
                        <wpNavi location="primary-menu" />
                    </div>

                    <div class="inner-wrapper main-content">
                        <div class="header-content">
                            <h1 v-html="currentPage.title.rendered"></h1>
                            <p class="intro" v-if="currentPage.acf.top_intro" v-html="currentPage.acf.top_intro"></p>
                            <template v-if="currentPage.acf.top_button && currentPage.acf.top_button.url && currentPage.acf.top_button.title">
                                <a class="btn btn-light" :href="currentPage.acf.top_button.url" v-html="currentPage.acf.top_button.title"></a>
                            </template>
                        </div>
                    </div>
                </section>

                <wpImage 
                    v-if="currentPage.featured_image_src"
                    :data="currentPage.featured_image_src" 
                    size="extra_large"
                    class="header-full"
                    background
                    lazy
                />

            </section>

        </template>
        <template v-else>

            <div class="nav-wrapper light" v-bind:class="{ 'open' : openNav}">
                    <router-link to="/" class="logo-wrapper">
                        <wpImage 
                            v-if="logoColor"
                            :data="logoColor" 
                            class="page-logo"
                        />
                    </router-link>
                    <div class="burger-wrapper">
                        <div 
                            class="hamburger hamburger--slider"
                            v-on:click="openNav = !openNav"
                            role="button"
                        >
                            <div class="hamburger-box">
                            <div class="hamburger-inner"></div>
                            </div>
                        </div>
                    </div>
                    <wpNavi location="primary-menu" />
                </div>
            
            <section v-if="currentPage.featured_media && currentPage.featured_image_src && currentPage.featured_image_src.url" class="top-section" :class="getCurrentRoute.meta.type">
                <wpImage 
                    v-if="currentPage.featured_image_src"
                    :data="currentPage.featured_image_src" 
                    size="extra_large"
                    class="header-single"
                    background
                    lazy
                />
                <template v-if="pageType === 'archive' || pageType === 'frontPage'" >
                    <div class="inner-wrapper main-content heading-box">
                        <div class="header-content">
                            <h1 v-html="currentPage.title.rendered"></h1>
                            <p class="intro" v-if="currentPage.acf.top_intro" v-html="currentPage.acf.top_intro"></p>
                            <template v-if="currentPage.acf.top_button && currentPage.acf.top_button.url && currentPage.acf.top_button.title">
                                <a class="btn btn-dark" :href="currentPage.acf.top_button.url" v-html="currentPage.acf.top_button.title"></a>
                            </template>
                        </div>
                    </div>
                </template>
            </section>

        </template>
    </header>
</template>

<script>
window.$ = window.jQuery;

    import wpNavi from '@/components/navigation/WpNavi'
    import wpImage from '@/components/elements/WpImage'

    import { mapGetters } from 'vuex'

    export default {
        name: 'theme-header',
        data() {
            return {
			    viewKey: window.location.pathname,
                routerPageType: this.$route.meta.type,
                routeName: this.$route.name,
                logoWhite: WPVUE.options.light,
                logoColor: WPVUE.options.dark,
                openNav: false,
            }
        },
        mounted(){
            //console.log(this.pageType)
        },
        components: {
            wpNavi,
            wpImage
        },
        computed: {
            ...mapGetters([
                'getCurrentRoute',
            ]),
            pageType(){
                return this.$route.meta.type
            }
        }
    }
</script>

<style lang="scss">
.page-header{
    .page-logo img{
        height: 83px;
        @media (max-width: 767px) {
            height: 60px;
        }
    }
}

</style>